// A dashboard widget: a card with the cloud-console-style header
// (drag grip · title · Info link · action slot). Purely presentational.
export default function Widget({
  title,
  info = false,
  action,
  children,
  className = '',
  flush = false,
}) {
  return (
    <section className={`widget ${className}`}>
      <header className="widget__header">
        <span className="widget__grip" aria-hidden="true">
          ⠿
        </span>
        <h2 className="widget__title">{title}</h2>
        {info ? (
          <a className="widget__info" href="#info" onClick={(e) => e.preventDefault()}>
            Info
          </a>
        ) : null}
        {action ? <div className="widget__actions">{action}</div> : null}
      </header>
      <div className={`widget__body ${flush ? 'widget__body--flush' : ''}`}>
        {children}
      </div>
    </section>
  );
}
